import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { C, card, label, btn, input } from "../lib/theme";

export default function Messages() {
  const [convs, setConvs] = useState([]);
  const [open, setOpen] = useState(null);
  const [thread, setThread] = useState(null);
  const [draft, setDraft] = useState("");
  const [to, setTo] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => { api.conversations().then(setConvs); }, []);
  useEffect(() => { if (open) api.thread(open).then(setThread); }, [open]);

  const send = (recipient) => api.send(recipient, draft)
    .then(() => { setDraft(""); setErr(""); if (open) api.thread(open).then(setThread);
      api.conversations().then(setConvs); })
    .catch((e) => setErr(e.message));

  return (
    <div style={{ maxWidth: 640 }}>
      <div style={{ ...card, marginBottom: 12, fontSize: 12, color: C.dim, lineHeight: 1.6 }}>
        Messages are private and are not routinely read — but they <b style={{ color: C.text }}>are
        stored</b>, and the recipient of any message can report it, which gives moderators access
        to the reported thread.
      </div>
      {!open && <>
        <div style={label}>CONVERSATIONS</div>
        {convs.map((c) => (
          <div key={c.with} onClick={() => setOpen(c.with)}
            style={{ ...card, padding: "12px 16px", marginBottom: 8, cursor: "pointer" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ fontSize: 13.5, fontWeight: 600 }}>{c.with}
                {c.unread > 0 && <span style={{ color: C.brass }}> ● {c.unread}</span>}</span>
            </div>
            <div style={{ fontSize: 12, color: C.dim, marginTop: 3, overflow: "hidden",
              whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
              {c.last_from_me ? "You: " : ""}{c.last}</div>
          </div>
        ))}
        <div style={{ ...card, padding: "12px 16px" }}>
          <div style={label}>NEW MESSAGE</div>
          <div style={{ display: "flex", gap: 8 }}>
            <input value={to} onChange={(e) => setTo(e.target.value)} placeholder="Display name"
              style={{ ...input, width: 180 }} />
            <input value={draft} onChange={(e) => setDraft(e.target.value)}
              placeholder="Message (text only)" style={{ ...input, flexGrow: 1 }} />
            <button style={btn()} onClick={() => to && send(to)}>Send</button>
          </div>
        </div>
      </>}
      {open && thread && <>
        <button onClick={() => { setOpen(null); api.conversations().then(setConvs); }}
          style={{ all: "unset", cursor: "pointer", color: C.brass, fontSize: 12.5,
            marginBottom: 10 }}>← Conversations</button>
        <div style={card}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 10 }}>{thread.with}</div>
          {thread.messages.map((m) => (
            <div key={m.id} style={{ display: "flex",
              justifyContent: m.from_me ? "flex-end" : "flex-start", marginBottom: 8 }}>
              <div style={{ maxWidth: "78%", background: m.from_me ? C.surface2 : C.bg,
                border: `1px solid ${C.line}`, borderRadius: 8, padding: "8px 12px" }}>
                <div style={{ fontSize: 12.5, lineHeight: 1.55 }}>{m.body}</div>
                {!m.from_me && (
                  <button onClick={() => api.reportDm(m.id, "harassment")
                    .then(() => setErr("Reported — moderators may review this thread."))}
                    style={{ all: "unset", cursor: "pointer", color: C.faint, fontSize: 9.5 }}>
                    report</button>)}
              </div>
            </div>
          ))}
          <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
            <input value={draft} onChange={(e) => setDraft(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && send(thread.with)}
              placeholder="Reply (text only)" style={{ ...input, flexGrow: 1 }} />
            <button style={btn()} onClick={() => send(thread.with)}>Send</button>
          </div>
          <button onClick={() => api.block(thread.with).then(() => setErr(`${thread.with} blocked.`))}
            style={{ all: "unset", cursor: "pointer", color: C.faint, fontSize: 11, marginTop: 8 }}>
            block this user</button>
        </div>
      </>}
      {err && <div style={{ color: C.brass, fontSize: 12, marginTop: 8 }}>{err}</div>}
    </div>
  );
}
